'use strict';

import React from 'react';
import FaCheck from 'react-icons/lib/fa/check'
import FaExclamationTriangle from 'react-icons/lib/fa/exclamation-triangle'

class InputField extends React.Component {
  constructor(props) {
    super(props);
    // this.handleChange = this.handleChange.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.validate = this.validate.bind(this);

    this.state = {
      valid: this.validate(props)
    }
  }

  componentWillUpdate(nextProps) {
    if (nextProps.value == this.props.value) return;
    this.setState({
      valid: this.validate(nextProps)
    });
  }

  validate(nextProps) {
    if (this.props.type == 'email') {
      return this.validateEmail(nextProps.value)
    } else if (this.props.type == 'checkbox') {
      return true
    } else {
      return nextProps.value.length > 0
    }
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  render() {
    const { errorMessage, options, ...rest } = this.props
    return (
    <div className={'site__form__input__container' + (this.props.type == 'checkbox' || this.props.type == 'select' ? ' checkbox' : '') + (this.props.hidden ? ' hidden': '' )}>
        {this.props.type != 'checkbox' && this.props.type != 'select' &&
          <span className={this.props.value.length > 0 ? 'site__form__input__hint active' : 'site__form__input__hint'}>{ this.props.hint }</span> &&
          <span className={this.props.value.length > 0 ? 'site__form__input__label active' : 'site__form__input__label'}>{ this.props.label }</span>
        }
        {this.props.type == 'area' &&
          <textarea {...rest} className="site__form__input"/>
        }
        {this.props.type == 'select' &&
        <div className="form-group">
          <label htmlFor="sel">{ this.props.label }</label>
          <select {...rest}  id="sel" className="form-control site__form__select">
            {this.props.options.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}
          </select>
        </div>
        }
        {this.props.type == 'checkbox' &&
          <label className="label site__form__checkbox">
            <input {...rest} className="label__checkbox" type="checkbox" />
            <span className="label__text">
              {this.props.label}
              <span className="label__check">
                <FaCheck />
              </span>
            </span>
          </label>
        }
        {this.props.type != 'area' && this.props.type != 'checkbox' && this.props.type != 'select' &&
          <input {...rest} className="site__form__input"/>
        }
        {this.props.type != 'checkbox' && this.props.type != 'select' && this.state.valid &&
          <span className="success indicator"><FaCheck /></span>
        }
        {this.props.type != 'checkbox' && this.props.type != 'select' && !this.state.valid &&
          <span className="error indicator"><FaExclamationTriangle /></span>
        }
        {this.props.type != 'checkbox' && this.props.type != 'select' && !this.state.valid &&
          <span className="site__form__input__error">{ errorMessage }</span>
        }
    </div>
    );
  }
}

InputField.displayName = 'InputField';

// Uncomment properties you need
// InputField.propTypes = {};
// InputField.defaultProps = {};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/InputField.js